export default "//uniclient-edge-assets.lmndstaging.com/small_logo__at__41400fa429d4445b7ce2573609a65b3e.svg"